import { render, staticRenderFns } from "./PreviewPromotion.vue?vue&type=template&id=20a4bc57&scoped=true&"
import script from "./PreviewPromotion.vue?vue&type=script&lang=ts&"
export * from "./PreviewPromotion.vue?vue&type=script&lang=ts&"
import style0 from "./PreviewPromotion.vue?vue&type=style&index=0&id=20a4bc57&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20a4bc57",
  null
  
)

export default component.exports